/*=========================================================================================
  File Name: moduleAttackMutations.js
  Description: Attack Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
    SET_ATTACKS(state, attacks) {
        state.attacks = attacks
    },
    SET_ATTACKHISTORY(state, attackDetails) {
        state.attackDetails = attackDetails
    },
    SET_WEBHOOKS(state, webHooks) {
        state.webHooks = webHooks
    },
    SET_DROPPED_EVENTS(state, droppedEvents) {
        state.droppedEvents = droppedEvents
    },
}